import type { ReactNode } from "react";

export const H5 = ({ children }: { children: ReactNode }) => {
  return (
    <h1 className="text-[16px] font-normal leading-[22px] text-[#0E0F0F]">
      {children}
    </h1>
  );
};
